import { render } from "./EditTerm.vue?vue&type=template&id=73b18c67"
import script from "./EditTerm.vue?vue&type=script&lang=js"
export * from "./EditTerm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__